import styled from "styled-components";

export const ClientFourthFoldWrapper = styled.div`
  height: 100%;
`;

export const StyledBanner = styled.div`
  margin: 104px 0px 0px;
`;
